/// <amd-module name="Pipeline/Analytics/Common/MockReportData" />

import { addDays, convertDateToDateString, getDate } from "Analytics/Shared/Utils/DateUtils";
import { IStageMetrics } from "./Types";
export const useMockData = document.cookie.indexOf("pipelineAnalytics.useMockData=true") >= 0;
export function getMockReportData() {
    const mockData = [
        {
            passPercentage: 75,
            failedCount: 55,
            taskFailures: [
                {
                    taskName: "L0 tests",
                    failedCount: 50
                },
                {
                    taskName: "L1 tests",
                    failedCount: 5
                }
            ]
        },

        {
            passPercentage: 100,
            failedCount: 0,
            taskFailures: []
        },

        {
            passPercentage: 100,
            failedCount: 0,
            taskFailures: []
        },

        {
            passPercentage: 80,
            failedCount: 43,
            taskFailures: [
                {
                    taskName: "L0 tests",
                    failedCount: 40
                },
                {
                    taskName: "L1 tests",
                    failedCount: 3
                }
            ]
        },

        {
            passPercentage: 90,
            failedCount: 21,
            taskFailures: [
                {
                    taskName: "L0 tests",
                    failedCount: 20
                },
                {
                    taskName: "L1 tests",
                    failedCount: 1
                }
            ]
        },

        {
            passPercentage: 100,
            failedCount: 0,
            taskFailures: []
        },

        {
            passPercentage: 93,
            failedCount: 20,
            taskFailures: [
                {
                    taskName: "Build solution",
                    failedCount: 20
                }
            ]
        },

        {
            passPercentage: 96,
            failedCount: 5,
            taskFailures: [
                {
                    taskName: "Update artifacts",
                    failedCount: 5
                }
            ]
        },

        {
            passPercentage: 40,
            failedCount: 90,
            taskFailures: [
                {
                    taskName: "L0 tests",
                    failedCount: 90
                }
            ]
        },

        {
            passPercentage: 100,
            failedCount: 0,
            taskFailures: []
        },

        {
            passPercentage: 100,
            failedCount: 0,
            taskFailures: []
        },

        {
            passPercentage: 90,
            failedCount: 5,
            taskFailures: [
                {
                    taskName: "Publish to artifact services drop a very very long task name. So long that it can literally overflow",
                    failedCount: 5
                }
            ]
        },

        {
            passPercentage: 80,
            failedCount: 23,
            taskFailures: [
                {
                    taskName: "Publish test results",
                    failedCount: 23
                }
            ]
        },

        {
            passPercentage: 75,
            failedCount: 23,
            taskFailures: [
                {
                    taskName: "L0 tests",
                    failedCount: 23
                }
            ]
        }
    ];

    const currentDate = getDate();
    const startDate = addDays(currentDate, -13);
    for (let i = 0; i < mockData.length; i++) {
        (mockData[i] as any)["date"] = convertDateToDateString(addDays(startDate, i));
    }

    return mockData;
}

export const mockReportData = getMockReportData();
export const totalFailedCount = mockReportData.map(r => r.failedCount || 0).reduce((a, b) => a + b);

export const totalCount = Math.round(
    mockReportData
        .map(r => {
            if (r.failedCount && r.passPercentage) {
                return (r.failedCount * 100) / (100 - r.passPercentage);
            } else {
                return 0;
            }
        })
        .reduce((a, b) => a + b)
);

export const taskFailureMap: { [task: string]: number } = {};
mockReportData.forEach(r => {
    r.taskFailures.forEach(t => {
        if (taskFailureMap[t.taskName] == null) {
            taskFailureMap[t.taskName] = 0;
        }

        taskFailureMap[t.taskName] += t.failedCount;
    });
});

export const taskFailures = Object.keys(taskFailureMap)
    .map(t => {
        return { taskName: t, failedCount: taskFailureMap[t] };
    })
    .sort((a, b) => b.failedCount - a.failedCount);

export const stageFailureDistribution = [0.5, 0.2, 0.2, 0.1];
export function getMockStageData(): IStageMetrics[] {
    const stages: IStageMetrics[] = [
        {
            fullName: "Build",
            name: "Build",
            dataCount: totalFailedCount * stageFailureDistribution[0]
        },
        {
            fullName: "_generatedDefaultForEmpty.stage1",
            name: "stage1",
            dataCount: totalFailedCount * stageFailureDistribution[1]
        },
        {
            fullName: "Staging",
            name: "Staging",
            dataCount: totalFailedCount * stageFailureDistribution[2]
        },
        {
            fullName: "Prod",
            name: "Prod",
            dataCount: totalFailedCount * stageFailureDistribution[3]
        }
    ];
    return stages;
}

export function getMoreMockStageData(): IStageMetrics[] {
    const stages: IStageMetrics[] = [
        {
            fullName: "Build",
            name: "Build",
            dataCount: totalFailedCount * 0.5
        },
        {
            fullName: "_generatedDefaultForEmpty.stage1",
            name: "stage1",
            dataCount: totalFailedCount * 0.1
        },
        {
            fullName: "Staging",
            name: "Staging",
            dataCount: totalFailedCount * 0.1
        },
        {
            fullName: "Prod",
            name: "Prod",
            dataCount: totalFailedCount * 0.1
        },
        {
            fullName: "Build1",
            name: "Build",
            dataCount: totalFailedCount * 0.03
        },
        {
            fullName: "_generatedDefaultForEmpty.stage2",
            name: "stage2",
            dataCount: totalFailedCount * 0.03
        },
        {
            fullName: "Staging1",
            name: "Staging1",
            dataCount: totalFailedCount * 0.03
        },
        {
            fullName: "Prod1",
            name: "Prod1",
            dataCount: totalFailedCount * 0.03
        },
        {
            fullName: "Build2",
            name: "Build2",
            dataCount: totalFailedCount * 0.03
        },
        {
            fullName: "_generatedDefaultForEmpty.stage3",
            name: "stage3",
            dataCount: totalFailedCount * 0.02
        },
        {
            fullName: "Staging2",
            name: "Staging2",
            dataCount: totalFailedCount * 0.02
        },
        {
            fullName: "Prod2",
            name: "Prod2",
            dataCount: totalFailedCount * 0.01
        }
    ];
    return stages;
}
